import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class CardFormatterService {
	formatedCardNumber: any;
	lastCardNumberValue: any;

	cardIsInvalid: any = false;
	cardType: any = "Unknown";

	card_types = [
		{
			name: 'American Express',
			code: 'ax',
			pattern: /^3[47]/,
			valid_length: [15],
			formats : [
				{
					length: 15,
					format: 'xxxx xxxxxxx xxxx'
				}
			]
		}, {
			name: 'Diners Club',
			code: 'dc',
			pattern: /^3[68]/,
			valid_length: [14],
			formats : [
				{
					length: 14,
					format: 'xxxx xxxx xxxx xx'
				}
			]
		}, {
			name: 'JCB',
			code: 'jc',
			pattern: /^35/,
			valid_length: [16],
			formats : [
				{
					length: 16,
					format: 'xxxx xxxx xxxx xxxx'
				}
			]
		}, {
			name: 'Visa',
			code: 'vs',
			pattern: /^4/,
			valid_length: [16],
			formats : [
				{
					length: 16,
					format: 'xxxx xxxx xxxx xxxx'
				}
			]
		}, {
			name: 'Mastercard',
			code: 'mc',
			pattern: /^5[1-5]/,
			valid_length: [16],
			formats : [
				{
					length: 16,
					format: 'xxxx xxxx xxxx xxxx'
				}
			]
		}, {
			name: 'Discover',
			code: 'dis',
			pattern: /^6/,
			valid_length: [16],
			formats : [
				{
					length: 16,
					format: 'xxxx xxxx xxxx xxxx'
				}
			]
		}
	];

	cardTypeChangeEvent = new Subject();
	
	isValidLength = function(cc_num, card_type) {
		for(var i in card_type.valid_length) {
			if (cc_num.length <= card_type.valid_length[i]) {
				return true;
			}
		}
		return false;
	};
	
	getCardType = function(cc_num) {
		for(var i in this.card_types) {
			var card_type = this.card_types[i];
			if (cc_num.match(card_type.pattern) && this.isValidLength(cc_num, card_type)) {
				return card_type;
			}
		}
	};
	
	getCardFormatString = function(cc_num, card_type) {
		for(var i in card_type.formats) {
			var format = card_type.formats[i];
			if (cc_num.length <= format.length) {
				return format.format;
			}
		}
	};
	
	formatCardNumber = function(cc_num, card_type) {
		var numAppendedChars = 0;
		var formattedNumber = '';
		
		if (!card_type) {
			return cc_num;
		}
		
		var cardFormatString = this.getCardFormatString(cc_num, card_type);
		for(var i = 0; i < cc_num.length; i++) {
			var cardFormatIndex = i + numAppendedChars;

			if (!cardFormatString || cardFormatIndex >= cardFormatString.length) {
				return cc_num;
			}
			
			if (cardFormatString.charAt(cardFormatIndex) !== 'x') {
				numAppendedChars++;
				formattedNumber += cardFormatString.charAt(cardFormatIndex) + cc_num.charAt(i);
			} else {
				formattedNumber += cc_num.charAt(i);
			}
		}
		
		return formattedNumber;
	};
	
	monitorCcFormat = function($elem) {
		var cc_num = $elem.val().replace(/\D/g,'');
		var card_type = this.getCardType(cc_num);



		if(card_type){
			this.cardIsInvalid = true;
			this.cardType = card_type.name;

			this.cardTypeChangeEvent.next(this.cardType);

			this.formatedCardNumber = this.formatCardNumber(cc_num, card_type);

			this.lastCardNumberValue = this.formatedCardNumber;

			$elem.val(this.formatedCardNumber);

			this.addCardClassIdentifier($elem, card_type);			
		}else{
			this.cardIsInvalid = false;
			this.cardType = "Unknown";

			this.cardTypeChangeEvent.next(this.cardType);
			
			this.formatedCardNumber = this.lastCardNumberValue;
			}			
	};
	
	addCardClassIdentifier = function($elem, card_type) {
		var classIdentifier = 'cc_type_unknown';
		if (card_type) {
			classIdentifier = 'cc_type_' + card_type.code;
		}
		
		if (!$elem.hasClass(classIdentifier)) {
			var classes = '';
			for(var i in this.card_types) {
				classes += 'cc_type_' + this.card_types[i].code + ' ';
			}
			$elem.removeClass(classes + 'cc_type_unknown');
			$elem.addClass(classIdentifier);
		}
	};	
}
	